import { Divider, Switch } from 'antd';
import startCase from 'lodash/startCase';
import { SingleTimeSlotConfigurationHeaderProps } from '@modules/timetable';

export const SingleTimeSlotConfigurationHeader = ({
  applyToAll,
  dayOfWeek,
  setApplyToAll,
}: SingleTimeSlotConfigurationHeaderProps) => {
  return (
    <Divider orientation="left">
      {applyToAll ? 'Daily Slots ' : `${startCase(dayOfWeek.name)} (${dayOfWeek.date})`}
      {dayOfWeek.name === 'monday' && (
        <div className="timetable-apply-to-all-button">
          &nbsp;
          <Switch
            size="small"
            checked={applyToAll}
            onChange={(checked) => {
              setApplyToAll(checked);
            }}
          />
          &nbsp; Apply to all
        </div>
      )}
    </Divider>
  );
};
